// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>20</span>&nbsp;&nbsp;You led your people like sheep&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;by the hand of Moses and Aaron.<br> </p> </div></div>";
// Exports
module.exports = code;